import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { init } from "@cleverbase-trust-drivers/shared/sentry/Events";
import { deriveEnv } from "@cleverbase-trust-drivers/shared/Environments";

init(
  "https://11f6f798edcdb5cf5c174bbd849a6d7b@o123883.ingest.us.sentry.io/4507702167470080",
  deriveEnv(window.location.hostname),
  "identification",
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
